import { Module, Commit, ActionTree, MutationTree } from 'vuex';
import type { MapConfigType } from '@/typings/customilyElements/canvasElements';
import { MapStylePresetType } from '@/components/DesignStudio/MapStyleProperties/types';

export interface MapStylePropertiesState {
    mapConfig: MapConfigType | undefined;
    selectedPreset: MapStylePresetType | undefined;
    selectedMapStyle: string | undefined;
    modalAddIsOpen: boolean;
    modalEditIsOpen: boolean;
    searchQuery: string;
}

const defaultState: MapStylePropertiesState = {
    mapConfig: undefined,
    selectedPreset: undefined,
    selectedMapStyle: undefined,
    modalAddIsOpen: false,
    modalEditIsOpen: false,
    searchQuery: ''
};

const getters = {
    selectedMapStyle: (state: MapStylePropertiesState) => state.selectedMapStyle,
    searchQuery: (state: MapStylePropertiesState) => state.searchQuery
};

const mutations: MutationTree<MapStylePropertiesState> = {
    setModalAddIsOpen: (state, payload: boolean) => {
        state.modalAddIsOpen = payload;
    },
    resetModalState: (state) => {
        state.mapConfig = undefined;
        state.selectedMapStyle = undefined;
        state.searchQuery = '';
    },
    selectMapStyle: (state, payload: string | undefined) => {
        state.selectedMapStyle = payload;
    },
    selectPreset: (state, payload: MapStylePresetType | undefined) => {
        state.selectedPreset = payload;
    },
    updateSearchQuery: (state, payload: string) => {
        state.searchQuery = payload;
    }
};

const actions: ActionTree<MapStylePropertiesState, MapStylePropertiesState> = {
    openAddModal({ commit }) {
        commit('setModalAddIsOpen', true);
    },
    closeAddModal({ commit }) {
        commit('setModalAddIsOpen', false);
    },
    resetModalState({ commit }: { commit: Commit }) {
        commit('resetModalState');
    },
    selectMapStyle({ commit }: { commit: Commit }, payload: string | undefined) {
        commit('selectMapStyle', payload);
    },
    selectPreset({ commit }: { commit: Commit }, payload: string | undefined) {
        commit('selectPreset', payload);
    },
    updateSearchQuery({ commit }: { commit: Commit }, payload: string) {
        commit('updateSearchQuery', payload);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const store: Module<MapStylePropertiesState, any> = {
    namespaced: true,
    state: defaultState,
    getters: getters,
    mutations: mutations,
    actions: actions
};
